import data from 'unicode-emoji-json/data-by-emoji.json'

export interface EmojiEntry {
  char: string
  name: string
}

const ENTRIES: readonly EmojiEntry[] = Object.entries(data as Record<string, { name: string }>).map(([char, meta]) => ({
  char,
  name: meta.name,
}))

export const searchEmoji = (query: string, limit: number): EmojiEntry[] => {
  const trimmed = query.trim().toLowerCase()
  const out: EmojiEntry[] = []

  for (const entry of ENTRIES) {
    if (trimmed.length === 0 || entry.name.includes(trimmed)) {
      out.push(entry)

      if (out.length >= limit) {
        break
      }
    }
  }

  return out
}
